<div class="container-fluid">
    <div class="row">
        <div class="col-md-6 footer-copyright">
            <p class="mb-0">Copyright {{ currentYear }} © Banco Central de Reserva de El Salvador. Todos los derechos reservados..</p>
        </div>
        <div class="col-md-6">
            
        </div>
    </div>
</div>